import { Checkbox } from "antd";
import React from "react";
import "./../index.css";

function CheckBoxGrey({
  checked = false,
  className,
  onChange,
  disabled = false,
}) {
  return (
    <div
      onClick={(e) => {
        e.stopPropagation(); // Stop propagation at the cell level
      }}
      className={`
        flex items-center justify-center flex-row  custom-checkbox`}
    >
      <Checkbox
        onClick={(e) => {
          e?.stopPropagation(); // Stop propagation at the cell level
        }}
        onChange={(e) => onChange(e.target.checked)}
        checked={checked}
        className={`custom-checkbox ${className}`}
        disabled={disabled}
      />
      {/* Optional label styling */}
    </div>
  );
}

export default CheckBoxGrey;
